import { Badge } from "@/components/ui/badge";
import {
  CheckCircle,
  Clock,
  AlertTriangle,
  XCircle,
  CheckCircle2,
} from "lucide-react";
import { cn } from "@/lib/utils";

type StatusType = string;

interface StatusConfig {
  icon: React.ElementType;
  className: string;
}

const STATUS_CONFIG: Record<string, StatusConfig> = {
  pending: {
    icon: Clock,
    className:
      "text-[var(--warning)] border-[var(--warning)]/30 bg-[var(--warning)]/10",
  },
  processing: {
    icon: Clock,
    className:
      "text-[var(--warning)] border-[var(--warning)]/30 bg-[var(--warning)]/10",
  },
  processed: {
    icon: CheckCircle,
    className:
      "text-[var(--success)] border-[var(--success)]/30 bg-[var(--success)]/10",
  },
  reconciled: {
    icon: CheckCircle2,
    className:
      "text-[var(--success)] border-[var(--success)]/30 bg-[var(--success)]/10",
  },
  matched: {
    icon: CheckCircle2,
    className:
      "text-[var(--primary)] border-[var(--primary)]/30 bg-[var(--primary)]/10",
  },
  uploaded: {
    icon: CheckCircle,
    className:
      "text-[var(--success)] border-[var(--success)]/30 bg-[var(--success)]/10",
  },
  ready: {
    icon: CheckCircle,
    className:
      "text-[var(--success)] border-[var(--success)]/30 bg-[var(--success)]/10",
  },
  error: {
    icon: XCircle,
    className:
      "text-[var(--destructive)] border-[var(--destructive)]/30 bg-[var(--destructive)]/10",
  },
  failed: {
    icon: XCircle,
    className:
      "text-[var(--destructive)] border-[var(--destructive)]/30 bg-[var(--destructive)]/10",
  },
  archived: {
    icon: AlertTriangle,
    className: "text-muted-foreground border-muted bg-muted/50",
  },
  deleted: {
    icon: XCircle,
    className: "text-muted-foreground border-muted bg-muted/50",
  },
};

const DEFAULT_CONFIG: StatusConfig = {
  icon: AlertTriangle,
  className: "text-muted-foreground border-muted bg-muted/50",
};

interface StatusBadgeProps {
  status: StatusType;
  className?: string;
}

export function StatusBadge({ status, className }: StatusBadgeProps) {
  const config = STATUS_CONFIG[status] ?? DEFAULT_CONFIG;
  const Icon = config.icon;
  return (
    <Badge
      variant="outline"
      className={cn(
        "gap-1 capitalize font-normal",
        config.className,
        className
      )}
    >
      <Icon className="h-3 w-3 shrink-0" />
      {status}
    </Badge>
  );
}
